import { authorities } from "@monorepo/utils/src/authorities/authorities";

export const isAuthorityExist = (user: { authorities: { authority: authorities }[] }, authority: authorities | authorities[]): boolean => {
  return !!user?.authorities?.find((element) => {
    return Array.isArray(authority) ? authority.includes(element.authority) : element.authority === authority;
  });
};
